module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M1.504 31.526c.96.576 2.144.64 3.137.128l25.605-12.799c1.088-.515 1.76-1.636 1.76-2.852s-.672-2.336-1.76-2.852L4.641.352A3.295 3.295 0 0 0 3.201 0c-.576 0-1.184.16-1.696.48A3.196 3.196 0 0 0 .001 3.201v25.605c0 1.12.576 2.144 1.504 2.721z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/play-2.js
// module id = 1345
// module chunks = 14